import { useServicesContext } from "@modules/core/services/services.context"
import { BoxPromoCodeEntity } from "@modules/promoCode/entities/boxPromoCodeEntity"
import { type BoxPromoCodeDraft } from "@modules/promoCode/types/boxPromoCodeTypes"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useBoxPromoCodesCreate = () => {
  const { boxPromoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: createBoxPromoCode, isPending } = useMutation({
    mutationFn: async (promoCodeDraft: BoxPromoCodeDraft) => {
      const updatedPromoCode = await boxPromoCodeApi.createBoxPromoCode(promoCodeDraft)
      return BoxPromoCodeEntity.fromDto(updatedPromoCode)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["boxPromoCodes"] })
    },
  })

  return {
    createBoxPromoCode,
    isPending,
  }
}

export const useBoxPromoCodesUpdate = () => {
  const { boxPromoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: updateBoxPromoCode, isPending } = useMutation({
    mutationFn: async ({ id, promoCodeDraft }: { id: string; promoCodeDraft: BoxPromoCodeDraft }) => {
      const updatedPromoCode = await boxPromoCodeApi.updateBoxPromoCode(id, promoCodeDraft)
      return BoxPromoCodeEntity.fromDto(updatedPromoCode)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["boxPromoCodes"] })
    },
  })

  return {
    updateBoxPromoCode,
    isPending,
  }
}

export const useBoxPromoCodesDelete = () => {
  const { boxPromoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteBoxPromoCode, isPending } = useMutation({
    mutationFn: async (id: string) => {
      return await boxPromoCodeApi.deleteBoxPromoCode(id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["boxPromoCodes"] })
    },
  })

  return {
    deleteBoxPromoCode,
    isPending,
  }
}
